export default __webpack_public_path__ + "static/Yoga-0c83da5cde26fee28944e27e797f8852.svg";